export default "/assets/images/dark-moss.jpg?f7f5de72b68a3b2c28b7579f162bdfaf";